import React, { useState, useEffect } from "react";
import { Navbar, PostList } from "../../../components/Student/Forum";
import { Post } from "../../../api";
import { useAuth } from "../../../hooks";
import { socket } from "../../../utils";
import "./Forum.scss";

const postController = new Post();

export function Forum() {
  const { accessToken } = useAuth();
  const [postList, setPostList] = useState({ data: [], pagination: {} });
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({ subjectId: "", order: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [filtersInitialized, setFiltersInitialized] = useState(false);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    socket.on("forumUpdate", onReload);
    return () => {
      socket.off("forumUpdate", onReload);
    };
  }, []);

  useEffect(() => {
    const handlePostCreated = (post) => {
      if (currentPage !== 1) return;
      if (post.status !== 1) return;
      if (filters.subjectId && String(post.subjectId) !== String(filters.subjectId)) return;
      setPostList((prev) => ({
        ...prev,
        data: [post, ...prev.data],
        pagination: {
          ...prev.pagination,
          totalItems: (prev.pagination?.totalItems || 0) + 1,
        },
      }));
    };
    socket.on("postCreated", handlePostCreated);
    return () => {
      socket.off("postCreated", handlePostCreated);
    };
  }, [currentPage, filters]);

  useEffect(() => {
    if (!filtersInitialized) return;
    
    (async () => {
      try {
        setLoading(true);
        setPostList({ data: [], pagination: {} });
        const response = await postController.getPosts(
          accessToken,
          filters,
          currentPage
        );
        setPostList(response);
      } catch (error) {
        // Error loading posts
      } finally {
        setLoading(false);
      }
    })();
  }, [filters, currentPage, reload, filtersInitialized]);

  return (
    <div className="student-forum">
      <h1 className="student-forum__title">Foro Académico</h1>
      <p className="student-forum__description">
        Participa en discusiones académicas, comparte conocimientos con tus compañeros y colabora en proyectos educativos. Aquí puedes crear publicaciones, responder preguntas y mantenerte conectado con la comunidad estudiantil.
      </p>
      <Navbar
        filters={filters}
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
        onReload={onReload}
        setFiltersInitialized={setFiltersInitialized}
      />
      <PostList
        setFilters={setFilters}
        postList={postList.data}
        loading={loading}
        onReload={onReload}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pagination={postList.pagination}
      />
    </div>
  );
}
